import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const pdfPrinter = () => {
    const store = useStore();
    const { commaFormat } = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, tableItems, totals, mopHeads, startDate = '', endDate = '', reportType = 'date') => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [30, 100, 30, 80],
            pageOrientation: 'portrait',
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(tableItems, totals, mopHeads, startDate, endDate, reportType),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
            },

            info: {
                title: 'Pos Collection Report',
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (tableItems, totals, mopHeads, startDate = '', endDate = '', reportType = 'date') => {
        return [
            {
                text: 'Pos Collection Report ' + '(' + startDate + ' to ' + endDate + ')',
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                style: 'tableExample',
                margin: [0, 30, 0, 0],
                table: {
                    body: getTableBody(tableItems, totals, mopHeads, reportType),
                    widths: generateTableWidths(7 + mopHeads.length),
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const getTableBody = (tableItems, totals, mopHeads, reportType = 'date') => {
        const body = [];

        // 1. Header row
        const headerRow = [
            { text: reportType === 'user' ? 'User' : 'Date', style: 'tableHeader', alignment: 'left' },
            { text: 'Total Amount', style: 'tableHeader', alignment: 'right' },
            { text: 'Discount', style: 'tableHeader', alignment: 'right' },
            { text: 'Reward Point Redeemed', style: 'tableHeader', alignment: 'right' },
            { text: 'Total Collection', style: 'tableHeader', alignment: 'right' },
            { text: 'Refund Payment', style: 'tableHeader', alignment: 'right' },
            { text: 'Net Collection', style: 'tableHeader', alignment: 'right' },
        ];

        mopHeads.forEach(mop => {
            headerRow.push({ text: mop.label, style: 'tableHeader', alignment: 'right' });
        });

        body.push(headerRow);

        // 2. Data rows
        tableItems.forEach(item => {
            const row = [
                reportType === 'user' ? (item.user_name || 'Walk-in Customer') : item.receipt_date,
                commaFormat(item.total_sale_amount),
                commaFormat(item.total_sale_discount),
                commaFormat(item.total_point_redeemed),
                commaFormat(item.total_paid_amount),
                commaFormat(item.total_refund_amount),
                commaFormat(item.total_paid_amount - item.total_refund_amount),
            ];

            mopHeads.forEach(mop => {
                row.push(commaFormat(item.mop_heads[mop.key] || 0));
            });

            body.push(row);
        });

        // 3. Totals row
        const totalsRow = [
            { text: 'Total', style: 'tableHeader', alignment: 'right' },
            commaFormat(totals.total_sale_amount),
            commaFormat(totals.total_sale_discount),
            commaFormat(totals.total_point_redeemed),
            commaFormat(totals.total_paid_amount),
            commaFormat(totals.total_refund_amount),
            commaFormat(totals.net_collection),
        ];

        mopHeads.forEach(mop => {
            totalsRow.push(commaFormat(totals.mop_heads[mop.key] || 0));
        });

        body.push(totalsRow);

        return body;
    }

    const generateTableWidths = (totalColumns) => {
        const widths = [];
        for (let i = 0; i < totalColumns; i++) {
            if(i == 1) {
                widths.push('*');
                return;
            }
            widths.push('auto');
        }
        return widths;
    }

    return {
        exportToPDF
    }

}

export default pdfPrinter;